<template>
  <div class="subject-bot" ref="dfContainer"></div>
</template>

<script>
export default {
  name: "AiTutorBot",
  props: {
    agentId: String,
    chatTitle: String
  },
  watch: {
    agentId: "renderBot",
    chatTitle: "renderBot"
  },
  methods: {
    renderBot() {
      console.log("this.agentId", this.agentId);
      sessionStorage.removeItem("df-messenger-messages")
      // Clear container and session storage
      this.$refs.dfContainer.innerHTML = "";
      const dfMessenger = document.createElement("df-messenger");
      dfMessenger.setAttribute("id", "chatbot");
      dfMessenger.setAttribute("project-id", "deft-axon-449307-f4");
      dfMessenger.setAttribute("agent-id", this.agentId);
      dfMessenger.setAttribute("language-code", "en");
      dfMessenger.setAttribute("session-id", `${this.agentId}-session-${Date.now()}`);
      dfMessenger.setAttribute("intent", `welcome`);

      dfMessenger.setAttribute(
        "style",
        `
          --df-messenger-chat-window-offset: 10px;
          --df-messenger-chat-window-height: 450px;
          --df-messenger-chat-window-width: 300px;
        `
      );

      dfMessenger.innerHTML = `
        <df-messenger-chat-bubble chat-title="${this.chatTitle}" chat-icon="/assets/images/KAIA-bubble-icon.svg" expanded></df-messenger-chat-bubble>
      `;

      this.$refs.dfContainer.appendChild(dfMessenger);

      dfMessenger.addEventListener("df-messenger-loaded", () => {
        //sessionStorage.clear();
        // Set cookie and query params after the bot is loaded
        const COOKIE_NAME = "uniqueUserId";
        const EXPIRATION_HOURS = 24;

        function getCookie(name) {
          const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
          return match ? match[2] : null;
        }

        function setCookie(name, value, hours) {
          const date = new Date();
          date.setTime(date.getTime() + hours * 60 * 60 * 1000);
          document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
        }

        let userId = getCookie(COOKIE_NAME);
        if (!userId) {
          userId = "user-" + Math.random().toString(36).substr(2, 9);
          setCookie(COOKIE_NAME, userId, EXPIRATION_HOURS);
        }
        const queryParameters = {
          parameters: {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            id: userId,
            originUrl: window.location.origin,
          },
        };

        dfMessenger.setQueryParameters(queryParameters);


      });

    }
    
  },
  mounted() {
    this.renderBot();
  }
};
</script>
